export default __webpack_public_path__ + "static/media/Roboto-MediumItalic.681fe2f5.woff";